const sortOrderAscending = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.99959 3.69727C10.1985 3.69727 10.3893 3.77628 10.5299 3.91694L13.8633 7.25027C14.1561 7.54316 14.1561 8.01804 13.8633 8.31093C13.5704 8.60382 13.0955 8.60382 12.8026 8.31093L9.99959 5.50793L7.19659 8.31093C6.9037 8.60382 6.42882 8.60382 6.13593 8.31093C5.84304 8.01804 5.84304 7.54316 6.13593 7.25027L9.46926 3.91694C9.60992 3.77628 9.80068 3.69727 9.99959 3.69727Z"
    fill="var(--fh-color-icon-default)"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.99894 16.3027C9.80003 16.3027 9.60926 16.2237 9.46861 16.0831L6.13528 12.7497C5.84239 12.4568 5.84239 11.982 6.13528 11.6891C6.42817 11.3962 6.90305 11.3962 7.19594 11.6891L9.99894 14.4921L12.8019 11.6891C13.0948 11.3962 13.5697 11.3962 13.8626 11.6891C14.1555 11.982 14.1555 12.4568 13.8626 12.7497L10.5293 16.0831C10.3886 16.2237 10.1979 16.3027 9.99894 16.3027Z"
    fill="var(--fh-color-icon-disabled)"
  />
</svg>
`;
export {
  sortOrderAscending as default
};
//# sourceMappingURL=sortOrderAscending.mjs.map
